import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/app/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["PhotonMinimalPage"] */ "/home/runner/work/mdsite4/mdsite4/components/photon/photon-minimal-page.tsx");
